import {
  collection,
  query,
  where,
  getDocs,
  orderBy,
  doc,
  getDoc,
} from 'firebase/firestore';
import { useMemo } from 'react';
import { useFirebase } from '../contexts/FirebaseContext';

const ActivityUtils = () => {
  const { db } = useFirebase();
  const activitiesRef = collection(db, 'activities');

  const createUserQuery = (userId, ...conditions) => {
    return query(activitiesRef, where('user', '==', userId), ...conditions);
  };

  const dataFromQuery = async (q) => {
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
  };

  const getActivitiesForUser = async (userId) => {
    const q = createUserQuery(userId);
    const activityData = await dataFromQuery(q);
    console.log('activityData', activityData);
    const enhancedActivityData = await Promise.all(
      activityData?.map(async (activity) => {
        let gameData = null;
        if (activity?.game) {
          const game = await getDoc(doc(db, 'games', activity?.game));
          gameData = game.data();
        }
        let createdByUserData = null;
        if (activity?.createdBy) {
          const createdByUser = await getDoc(doc(db, 'users', activity?.createdBy));
          const userName = createdByUser.data()?.userName || createdByUser.data()?.username;
          createdByUserData = {
            ...createdByUser.data(),
            photoURL: createdByUser.data()?.profileImage || null,
            initial: userName?.charAt(0).toUpperCase() || '',
          };
        }
        return {
          ...activity,
          game: gameData,
          createdBy: createdByUserData,
        };
      })
    );
    return enhancedActivityData.sort((a, b) => b.timestamp - a.timestamp);
  };

  const getPendingActivitiesForUser = async (userId) => {
    const q = createUserQuery(userId, where('status', '==', 'pending'));
    return await dataFromQuery(q);
  };

  const getRecentActivitiesForUser = async (userId) => {
    const q = createUserQuery(userId, orderBy('timestamp', 'desc'));
    return await dataFromQuery(q);
  };

  return useMemo(
    () => ({
      getActivitiesForUser,
      getPendingActivitiesForUser,
      getRecentActivitiesForUser,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
};

export function useActivityUtils() {
  return ActivityUtils();
}
